import { render, staticRenderFns } from "./sales_rms_rmb_rml_buttons.vue?vue&type=template&id=d97dc182&"
import script from "./sales_rms_rmb_rml_buttons.vue?vue&type=script&lang=js&"
export * from "./sales_rms_rmb_rml_buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports